/**
 * Application configuration
 * 
 * This file centralizes all environment-specific configuration
 * to make it easier to manage different environments.
 */

// API URL based on environment; REACT_APP_API_URL (set at build time)
// overrides the defaults, e.g. REACT_APP_API_URL=https://my-backend/api
const API_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production'
    ? 'https://patients-empowered-production.up.railway.app/api'
    : 'http://localhost:8000/api');

// Environment detection
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = process.env.NODE_ENV === 'development';
const isTest = process.env.NODE_ENV === 'test';

// Feature flags
const FEATURES = {
  enableAnalytics: isProduction,
  debugMode: isDevelopment,
  mockApiCalls: isTest,
};

// Timeouts and limits
const TIMEOUTS = {
  apiRequestTimeout: 60000, // 60 seconds for all API calls (increased from 10s in production)
  llmApiRequestTimeout: 120000, // 120 seconds (2 minutes) for LLM API calls (Claude, etc.)
  sessionTimeout: 3600000, // 1 hour in milliseconds
};

// Export configuration
const config = {
  API_URL,
  isProduction,
  isDevelopment,
  isTest,
  FEATURES,
  TIMEOUTS,
};

export default config;
